import DateTimeUtils from '@/lib/dateTimeUtils';

export default (value: Date) => {
    const date = new Date(value)  
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
    //console.log(`${da}-${mo}-${ye}`);
    //return DateTimeUtils.toShortDate(date);
    return `${da}/${mo}/${ye}`;
} 